export default __webpack_public_path__ + "static/media/Banner.a6e9b723.png";